import React from 'react';
import { Route } from 'react-router-dom';
import RouteMenu from 'mrf/view/MenuRoute';
import path from 'path';
import CommunicationProcessList from './communicationProcessList';
import CommunicationProcessView from 'components/transfers/communicationProcessView';

export default function Transfers({ match }) {
    return (
        <RouteMenu match={match} indexComponent={CommunicationProcessList}>
            <Route path={path.join(match.url, 'view/:id')} component={CommunicationProcessView} />
        </RouteMenu>
    );
}